import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { formatDataTestId } from '../../utils/formatters';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BookingNotConfirmed(_ref) {
  var t = _ref.t;
  var baseDataTestId = 'BookingNotConfirmed';
  return _jsx(Box, _objectSpread(_objectSpread({}, contentWrapperStyle), {}, {
    sx: {
      '@media print': {
        display: 'none'
      }
    },
    children: _jsx(Text, _objectSpread(_objectSpread({}, titleStyle), {}, {
      "data-testid": formatDataTestId(baseDataTestId, 'Title'),
      children: t('booking.confirmation.sorry')
    }))
  }));
}
var contentWrapperStyle = {
  w: 'full'
};
var titleStyle = {
  fontSize: '3xxl',
  fontWeight: 'semibold',
  mb: 'md'
};